export default class{
	constructor(wrapper, insert){
		this._createElements(wrapper, insert);
		this._addEventsName();
		this._addEvents();
	}

    _getHtml(){
        var data = {};
        data.advVideo = 'http://video.kinoafisha.info/branding/kinoafisha/kinoafisha-youtube3';
        data.advLink = 'https://www.youtube.com/channel/UCNuQyDGBj28VwMRhCy_hTOw';

        return  '<div data-js="adv-player" data-param="' +data.advVideo+'" class="advPlayer">'+
                    '<video data-js="adv-video" class="advPlayer_video"></video>'+
                    '<a data-js="adv-clicking-btn" class="advPlayer_link" target="_blank" href="'+data.advLink+'"></a>'+
                    '<div class="advPlayer_controls">'+
                        '<div class="advPlayer_controlsCell">'+
                            '<span class="advPlayer_param">Реклама.</span> <span data-js="adv-left" class="advPlayer_param">&nbsp;</span>'+
                        '</div>'+
                        '<div class="advPlayer_controlsCell">'+
                            '<a data-js="adv-skip-btn" class="advPlayer_param" href="#">&nbsp;</a>'+
                        '</div>'+
                     '</div>'+
                    '<div class="advPlayer_before">'+
                        '<div class="advPlayer_beforeContent">'+
                            '<div class="advPlayer_beforeContentItem">Реклама</div>'+
                        '</div>'+
                    '</div>'+
                    '<div class="advPlayer_preloader"></div>'+
                '</div>';
    }

	_createElements(wrapper, insert){ /* wrapper - общий контейнер, пока не используется */
        this.insert = insert;
        insert.innerHTML = this._getHtml();
        this.wrapper = insert.firstChild; /* wrapper - здесь - внутренний блок  */
		this.video = this.wrapper.querySelector('[data-js="adv-video"]');
		this.clickingBtn = this.wrapper.querySelector('[data-js="adv-clicking-btn"]');
		this.skipBtn = this.wrapper.querySelector('[data-js="adv-skip-btn"]');
		this.advLeft = this.wrapper.querySelector('[data-js="adv-left"]');
		this.format = 'mp4';
		this.userAgent = this._defineUserAgent();
	}

	_defineUserAgent(){
		var agentAll = ['ipod','iphone','ipad', 'android', 'blackberry'],
			i = 0;

		for(i;i< agentAll.length;i++){
			var re = new RegExp(agentAll[i], 'i');
			if( re.test( navigator.userAgent ) ) return agentAll[i];
		}
		return false;
	}

	_addEventsName(){
		this.eNames = {}
		if (window.navigator.pointerEnabled) this.eNames = {'down': 'pointerdown', 'move': 'pointermove', 'enter':'pointerenter', 'leave':'pointerleave', 'up': 'pointerup'};
		else if(window.navigator.msPointerEnabled) this.eNames = {'down': 'MSPointerDown', 'move': 'MSPointerMove', 'enter':'MSPointerEnter', 'leave':'MSPointerLeave', 'up': 'MSPointerUp'};
		else if('ontouchstart' in document.documentElement) {
			this.eNames = {'down': 'touchstart', 'move': 'touchmove', 'enter':'touchstart', 'leave':'touchend', 'up': 'touchend'};
		}
		else this.eNames = {'down': 'mousedown', 'move': 'mousemove', 'enter':'mouseenter', 'leave':'mouseleave', 'up': 'mouseup'};
	}

	_addEvents(){
		var self = this;

		this.video.onloadedmetadata = function (event){
			self._updateTimeCur.call(self, 0);
			self._ready.call(self);
		}

		this.video.ontimeupdate = function (){
			self._updateTimeCur.call(self, this.currentTime);
		}

		this.video.onended = function(){
			self._end.call(self);
		}

		this.skipBtn.onclick = function(){
			self._skip.call(self);
			return false;
		}

		this.clickingBtn.onclick = function(){
			self._clicking.call(self);
		}
	}

	_skip(){
		if(this.skipBtn.innerHTML !== 'Пропустить') return false;

		this.wrapper.className = this.wrapper.className.replace(/\s*advPlayer-active/, '');
		this.video.pause();
		this.afterSkip();
	}

	_clicking(){
		this.wrapper.className = this.wrapper.className.replace(/\s*advPlayer-active/, '');
		this.video.pause();
		this.afterClicking();
	}

	_end(){
		this.wrapper.className = this.wrapper.className.replace(/\s*advPlayer-active/, '');
		this.afterEnd(); //определяется в основном плеере
	}

	_reloadVideo(){
		this.wrapper.className = 'advPlayer advPlayer-active  advPlayer-waiting';

		this.video.innerHTML = '';
		var source = document.createElement('SOURCE');
		source.setAttribute('src', this.wrapper.getAttribute('data-param') + '.' + this.format);
		source.setAttribute('type', 'video/' + this.format);
		this.video.appendChild(source);
		this.video.load();
	}

	_updateTimeCur(sec){
		var leftTime = Math.floor(this.video.duration - sec),
			text = leftTime ? ('Осталось ' + leftTime + 'сек') : '&nbsp;',
			skipTime = Math.round(2 - sec);

		this.advLeft.innerHTML = text;

		if(skipTime > 0 && this.userAgent !== 'iphone') this.skipBtn.innerHTML = 'Пропустить через ' + skipTime; //В айфоне всегда можно закрыть
		else this.skipBtn.innerHTML = 'Пропустить';
	}

	_ready(){
		var self = this;

		//this.video.currentTime = 2;

		if( this.userAgent === 'iphone'){
			this.wrapper.className = 'advPlayer advPlayer-ready advPlayer-active advPlayer-before';
			setTimeout(function(){
				self.wrapper.className = 'advPlayer advPlayer-ready advPlayer-active';
				self.video.play();
			}, 1500);
		}
		else {
			this.wrapper.className = 'advPlayer advPlayer-ready advPlayer-active';
			this.video.play();
		}
	}

	initialize(){
		this.video.innerHTML = '';
		this.video.load();
	}

	show(){
		var self = this;
		self._reloadVideo.call(self);
	}

    del(){
        this.video.onloadedmetadata = function(){};
        this.video.innerHTML = '';
        this.video.setAttribute('src', '');
        this.insert.innerHTML = '';
    }
}





